import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Modal } from 'containers/misc'
import { AssessorReport } from 'containers/sections/assessors'
import { get } from 'lodash'
import { Table, Data } from 'components/layout/Table'
import { Status, Button } from 'components/misc'
import { ajEvents as ajEventsLayout } from 'constants/layout'
import config from 'config'

export default class AjInfoTable extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired
  }

  key = uuid.v1()

  render() {
    const { data } = this.props

    const isAssessmentPositive = get(
      data,
      'participantEvent.isAssessmentPositive'
    )
    const returnedToParticipant = get(
      data,
      'participantEvent.returnedToParticipant'
    )
    const assessmentActionId = get(
      data,
      'participantEvent.ajParticipantEventAssessmentActionId'
    )

    return (
      <div>
        <Table ths={ajEventsLayout.infoTable}>
          <Data>
            <tr>
              <td>
                <Link to={`${config.publicPath}/adventurous-journeys/${get(data, 'id')}/detail`}>
                  {get(data, 'id')}
                </Link>
              </td>
              <td>
                {get(data, 'startDate') && (
                  <FormattedDate value={data.startDate} />
                )}
              </td>
              <td style={{ width: 200 }}>
                {isAssessmentPositive &&
                !returnedToParticipant && (
                  <Status state={isAssessmentPositive} check />
                )}
                {!isAssessmentPositive &&
                returnedToParticipant &&
                assessmentActionId !== null && (
                  <FormattedMessage
                    id="assessor_report.returned_to_participant"
                    defaultMessage="Returned to participant"
                  />
                )}
                {!isAssessmentPositive && !returnedToParticipant && '---'}
              </td>
              <td>
                {assessmentActionId && isAssessmentPositive ? (
                  <Button
                    link
                    type="button"
                    intlKey="button.view"
                    onClick={() =>
                      this.props.modal(
                        `modal-display-assessor-report-${this.key}`
                      )}
                  >
                    View
                  </Button>
                ) : (
                  '---'
                )}
              </td>
            </tr>
          </Data>
        </Table>
        <Modal id={`modal-display-assessor-report-${this.key}`}>
          <AssessorReport
            id={get(data, 'participantEvent.id')}
            actionId={assessmentActionId}
            isParticipantEvent
            assessed={isAssessmentPositive}
          />
        </Modal>
      </div>
    )
  }
}
